import { createStore } from 'effector';
import { SitesMap } from './entities';

export const $sitesMap = createStore<SitesMap | null>(null);
